export const NotFoundPage = () => {
    return (
        <h1>Page Does Not Exist</h1>
    )
}